module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('plex-header'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('plex-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19ae9f6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/normalPage/NormalPage.vue
// module id = 1271
// module chunks = 1